import {Pipe, PipeTransform} from '@angular/core';

export const toReadableText = (value: string): string => {
    let newValue = value.toLocaleLowerCase();
    while (newValue.indexOf('_') != -1) {
      newValue = newValue.replace('_', ' ')
    }
    let firstCharacter = newValue.charAt(0).toLocaleUpperCase();
    newValue = newValue.substring(1, newValue.length);
    return firstCharacter + newValue;
}

@Pipe({
  name: 'toReadableText',
  standalone: true
})
export class ToReadableTextPipe implements PipeTransform {
  constructor() {
  }
  
  public transform(value: string): string {
    return toReadableText(value);
  }
}